import { config } from 'src/config'
export default {
  URL: 'oauth/access_token',
  GRANT_TYPE: config('oauth.grant_type', 'password'),
  CLIENT_ID: config('oauth.client_id', 'default'),
  CLIENT_SECRET: config('oauth.client_secret', 'abcdef'),
  GQL_CLIENT_ID: config('gql.client_id', 'default'),
  GQL_CLIENT_NAME: config('gql.client_name', 'client_name'),
  GQL_CLIENT_SECRET: config('gql.client_secret', 'abcdef')
}
